import { ExhibitHallViewInfo } from '@/types';
import React from 'react';
import styled from 'styled-components';
import IntroContent from './IntroContent';

interface HgTabProps {
  data?: ExhibitHallViewInfo;
}

const HgTab = ({ data }: HgTabProps) => {
  return (
    <>
      <IntroContent data={data} />
      <ContentBox src={`http:${data?.intro?.image?.url}`} alt="hgImg" />
    </>
  );
};

export default HgTab;

const ContentBox = styled.img`
  width: 770px;
  height: 840px;
`;
